<script setup>

import { ref } from 'vue';

// Get the consent cookie
const consentCookie = (typeof document !== 'undefined') ? document.cookie.split(';').find(c => c.trim().startsWith('consent=')) : undefined;

// Set the default consent status based on the cookie value
if (consentCookie !== undefined) {

	// Get the consent status from the cookie
	const consentStatus = consentCookie.split('=')[1];

	// Set default consent to the cookie value
	setConsent(consentStatus);

} else {

	// Set default consent to denied
	setConsent('denied');
}

// Check if GA4 is enabled in the .env file
const ga4Enabled = import.meta.env.VITE_GA4_ENABLED === 'true';

// Set the visibility of the popup
const isVisible = ref(consentCookie === undefined);

const grant = () => {

	// Set Google Analytics consent to granted
	setConsent('granted');

	// Hide the popup
	isVisible.value = false;

}

const deny = () => {

	// Hide the popup
	isVisible.value = false;
}

// Set the consent status for Google Analytics
const setConsent = (status) => {

	if (typeof gtag === 'function' && typeof document !== 'undefined') {
		gtag('consent', 'update', {
			'ad_storage': status,
			'ad_user_data': status,
			'ad_personalization': status,
			'analytics_storage': status
		});

		// Set the cookie to the consent status
		document.cookie = "consent=" + status + "; expires=Fri, 31 Dec 9999 23:59:59 GMT";
	}
}

</script>

<template>

	<Transition name="fade-y">

		<div v-if="ga4Enabled && isVisible" id="consentPopupBackground">
			<div id="consentPopup">
				<h3 class="mb-3">{{ __('privacy_settings') }}</h3>
				<p class="text-small text-grey">{{ __('privacy_message') }}</p>
				<div class="d-flex justify-content-between flex-column flex-sm-row w-100 gap-2 mt-4">
					<button class="btn btn-secondary" @click="deny()">
						{{ __('deny') }}
					</button>
					<button class="btn btn-primary  flex-grow-1" @click="grant()">
						{{ __('accept') }}
					</button>
				</div>
			</div>
		</div>

	</Transition>

</template>

<style scoped></style>